/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect} from 'react';
// noinspection ES6CheckImport
import {useHistory} from 'react-router-dom';
import {Pagination, Table} from 'antd';
import CurrencyFormat from 'react-currency-format';
import Button from '@material-ui/core/Button';
import {formatDate} from '../../modules/utils';
import {useDispatch, useSelector} from 'react-redux';
import {
  SELECTOR_ORDERS,
  SELECTOR_ORDERS_TOTALS,
} from '../../redux/selectors/orders';
import {getOrders} from '../../redux/actions';

import 'antd/dist/antd.css';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { createCartFromOrderId } from '../../redux/actions/shoppingCart';
import { Box } from '@material-ui/core';
import { ShoppingBasket } from '@material-ui/icons';

function OrdersTable() {
  const orders = useSelector(SELECTOR_ORDERS);
  const pagination = useSelector(SELECTOR_ORDERS_TOTALS);

  const isMobil = useMediaQuery('(max-width:510px)');
  const dispatch = useDispatch();
  const history = useHistory();

  const columns = isMobil
    ? [
        {
          render: ({id, createdAt: date, total_price: price, status, ...record}) => {
            return (
              <div>
                <div>
                  Pedido Nro: <span>{id}</span>
                </div>
                <div>
                  Fecha: <span>{formatDate(date)}</span>
                </div>
                <div>
                  Valor total:
                  <CurrencyFormat
                    value={price}
                    displayType={'text'}
                    thousandSeparator={true}
                    prefix={'$'}
                    renderText={(value) => <span>{value}</span>}
                  />
                </div>
                <div>
                  Estado: <span>{status.name}</span>
                </div>
                <Box display="flex" gridGap={10}>
                  <Button
                    variant="outlined"
                    size="small"
                    color="primary"
                    onClick={() => history.push(`/mi-cuenta/mis-pedidos/${id}`)}
                  >
                    Ver detalle del pedido
                  </Button>
                  {[3, 5, 6, 7, 8, 9].includes(record.order_status_id) && (
                    <Button
                      variant="outlined"
                      size="small"
                      color="secondary"
                      onClick={() => {
                        dispatch(createCartFromOrderId(record.id))
                      }}
                    >
                      <ShoppingBasket />
                    </Button>
                  )}
                </Box>
              </div>
            );
          },
        },
      ]
    : [
        {
          title: 'Pedido Nro.',
          dataIndex: 'id',
          sorter: false,
          width: '20%',
        },
        {
          title: 'Comprado el',
          dataIndex: 'createdAt',
          sorter: false,
          width: '20%',
          render: (date) => <span>{formatDate(date)}</span>,
        },
        {
          title: 'Valor total',
          dataIndex: 'total_price',
          render: (price) => (
            <CurrencyFormat
              value={price}
              displayType={'text'}
              thousandSeparator={true}
              prefix={'$'}
              renderText={(value) => <span>{value}</span>}
            />
          ),
        },
        {
          title: 'Estado',
          render: ({status}) => {
            return status.name;
          },
        },
        {
          title: '',
          // dataIndex: 'id',
          render: (record) => (
            <Box display="flex" gridGap={10}>
               <Button
                  variant="outlined"
                  size="small"
                  color="primary"
                  onClick={() => history.push(`/mi-cuenta/mis-pedidos/${record.id}`)}
                >
                  Ver detalle del pedido
              </Button>
              {[3, 5, 6, 7, 8, 9].includes(record.order_status_id) && (
                <Button
                  variant="outlined"
                  size="small"
                  color="secondary"
                  onClick={() => {
                    dispatch(createCartFromOrderId(record.id))
                  }}
                >
                  <ShoppingBasket />
                </Button>
              )}
            </Box>
          ),
        },
      ];

  useEffect(() => {
    getOrderData(0);
  }, []);

  function getOrderData(skip) {
    dispatch(getOrders({query: {$skip: skip}}));
  }

  return (
    <div>
      <Table
        columns={columns}
        rowKey={(item) => item.id}
        dataSource={orders.reverse()}
        pagination={false}
      />
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          paddingTop: 15,
        }}
      >
        <Pagination
          total={pagination.total}
          showSizeChanger={false}
          defaultPageSize={10}
          defaultCurrent={1}
          onChange={(current, pageSize) => {
            getOrderData((current - 1) * pageSize);
          }}
        />
      </div>
    </div>
  );
}

export default OrdersTable;
